import { AUTH_STORE_NAMESPACE } from '../config'
import * as storage from './storage'

// Access tokens now come from Amplify on every request (see utils/authSession),
// so nothing reads or writes this namespace any more. Only the cleanup remains,
// to drop the token copy left in localStorage by older builds.
export const clearAuthStoreData = () => {
  storage.removeItem(AUTH_STORE_NAMESPACE)
}
